import type { TranslateDictionary } from './en.js';

export const Pt: TranslateDictionary = {
  'Drop a video file here to upload': 'Arraste um arquivo de vídeo aqui para fazer o upload',
  or: 'ou',
  'Upload complete!': 'Upload completo!',
  Retry: 'Tentar novamente',
  'Pausing...': 'Pausando...',
  Resume: 'Retomar',
  Pause: 'Pausar',
  'Upload a video': 'Fazer upload de um vídeo',
  'No url or endpoint specified - cannot handle upload':
    'Nenhum URL ou endpoint especificado - não é possível processar o upload',
};
